// src/db/userDB.js
import Dexie from 'dexie'

// 1️⃣ 创建数据库实例
export const db = new Dexie('CustomerDB')

// 2️⃣ 定义表结构（相当于表和字段）
db.version(1).stores({
    users: 'id, customerId'
})

// 3️⃣ 封装操作方法
export const CustomerTable = {
    // 添加单个
    async add(user) {
        return await db.users.put(user)
    },

    // 批量添加
    async bulkAdd(list) {
        // 注意要去掉响应式对象
        const pureList = JSON.parse(JSON.stringify(list))
        return await db.users.bulkPut(pureList)
    },

    // 查询所有
    async getAll() {
        return await db.users.toArray()
    },

    // 按 id 查询
    async getById(id) {
        return await db.users.get(id)
    },

    // 删除指定 id
    async deleteById(id) {
        return await db.users.delete(id)
    },

    // 清空表
    async clear() {
        return await db.users.clear()
    },

    // 分页查询
    // 分页查询，同时返回总条数
    async getPageWithTotal(page = 1, pageSize = 20) {
        const total = await db.users.count() // 获取总条数
        const data = await db.users
            .offset((page - 1) * pageSize)
            .limit(pageSize)
            .toArray()
        return {data, total, pageSize} // 返回当前页数据 + 总条数
    }
}